import styled from 'styled-components';
import { ApRadio } from '@alixpartners/ui-components';

export const Radio = styled(ApRadio)`
	margin-right: 6px;
`;

export const RadioWrapper = styled.div`
	margin-top: 30px;

	label {
		font-size: 16px !important;
		margin-left: 6px;
		margin-top: 20px;
	}
`;
